// lib/post-url.ts
import type { PostNode } from "@/app/components/PostGrid";
import { toKnownSubject } from "@/lib/subject-guard";
import type { KnownSubject } from "@/lib/subject-guard";
import subjectPrefixMapJson from "@/lib/post-prefix-map.json";

export interface PostLike extends Pick<PostNode, "_sys"> {
  subject?: KnownSubject | null;
}

// Return the *public* URL for any blog-type document.
export function postUrl(post: PostLike): string {
  const subject = toKnownSubject(post.subject ?? undefined);
  const subjectPrefixMap = subjectPrefixMapJson as Record<string, string>;
  const prefix = (subject ? subjectPrefixMap[subject] : undefined) ?? "/blog";

  return `${prefix}/${post._sys.filename}`;
}
